import request from './requesters/zoho.request';

const zohoService = {
  getDocumentPdf: (documentId: string | undefined) => request.get(`/zoho/get-document-pdf/${documentId}`),
  createOrUpdateEstimate: (data: object) => request.post('/zoho/create-log-exchange', data),
};

export default zohoService;
